module.exports = __webpack_public_path__ + "static/img/top-img.cb9aeaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UL168/top-img.jpg
// module id = iDSC
// module chunks = 52